import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Select, MenuItem, InputLabel, Typography, FormControl } from '@mui/material';

import { WheelsPrice, WheelsPricingConfig, WheelsVehicleTypeId, WheelsZoneName } from '../../../domain/wheels';

interface Props {
  value: WheelsVehicleTypeId;
  pricingConfig: WheelsPricingConfig | null;
  zone: WheelsZoneName | null;
  onChange: (vehicle: WheelsVehicleTypeId, wheelsPrice: WheelsPrice) => void;
}

export const WheelsVehiclesSelect = ({ pricingConfig, value, zone, onChange }: Props) => {
  const { t } = useTranslation();

  const pricingByZone = pricingConfig?.pricing.find((pd) => pd.zone === zone);
  const vehicles =
    !!pricingConfig && pricingByZone
      ? pricingConfig.vehicleTypes.map((vehicle, index) => ({ ...vehicle, ...pricingByZone.prices[index] }))
      : [];

  const handleVehicleChange = (event) => {
    const vehicleTypeId: WheelsVehicleTypeId = event.target.value;

    const vehicleType = vehicles.find((vehicle) => vehicle.id === vehicleTypeId);

    if (!vehicleType) return null;

    onChange(vehicleTypeId, { price: vehicleType.price, vehicleType: vehicleType.id } /** Wheels price */);
  };

  return (
    <FormControl sx={{ width: '100%' }}>
      <InputLabel id="wheels-vehicles-select-label" sx={{ color: '#6C6D70' }}>
        {t('wheels_service.inputs.vehicle')}
      </InputLabel>
      <Select
        id="wheels-vehicles-select"
        label={t('wheels_service.inputs.vehicle')}
        value={value}
        disabled={!vehicles.length}
        labelId="wheels-vehicles-select-label"
        onChange={handleVehicleChange}
      >
        {vehicles.map(({ id, name, price }) => (
          <MenuItem key={id} value={id}>
            <Stack width="100%" flexDirection="row" justifyContent="space-between">
              <Typography variant="body2">{name}</Typography>
              <Typography variant="body2">${price.toFixed(2)} USD</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
